import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Hero } from "../components/landing/Hero";
import { EditorialMarquee } from "../components/landing/Marquee";
import { Features } from "../components/landing/Features";
import { HowItWorks, CtaBand } from "../components/landing/HowItWorks";
import { ComplianceSectors } from "../components/landing/ComplianceSectors";
import { BookSection } from "../components/landing/BookSection";
import { Pricing } from "../components/landing/Pricing";
import { ContactSection } from "../components/landing/ContactSection";

export default function Landing() {
  return (
    <div className="bg-white" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <Features />
        <HowItWorks />
        <ComplianceSectors />
        <BookSection />
        <Pricing />
        <ContactSection />
        <CtaBand />
      </main>
      <Footer />
    </div>
  );
}
